angular.module('picmonicng').controller('BrowsePracticeQuestionsController', [
  '$scope',
  'PQService',
  function ($scope, PQService) {
    $scope.PQService = PQService;
  },
]);
